import { useQuery } from '@tanstack/react-query';

import { getOrgMembers } from '@/features/org/api/get-org-members';
import { useCurrentOrg } from '@/features/org/hooks/use-org';

export const useOrgMembersForProject = () => {
  const { data: currentOrg } = useCurrentOrg();

  return useQuery({
    queryKey: ['orgMembersForProject', currentOrg?.id],
    queryFn: () => {
      if (!currentOrg?.id) {
        return [];
      }
      return getOrgMembers({ orgId: currentOrg.id });
    },
    enabled: !!currentOrg?.id,
  });
};
